import { Box, styled } from "@mui/material";


export const ContentContainer = styled(Box)({
    display: 'grid',
    placeItems: 'center stretch',
})